import { create_instance } from '../init';

class Tags {
    getTags(params) {
        return create_instance.get('/tag', { params });
    }
}

export default new Tags();
